import { render, staticRenderFns } from "./CookieBannerPanel.vue?vue&type=template&id=bc017de0&scoped=true"
import script from "./CookieBannerPanel.vue?vue&type=script&lang=js"
export * from "./CookieBannerPanel.vue?vue&type=script&lang=js"
import style0 from "./CookieBannerPanel.vue?vue&type=style&index=0&id=bc017de0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc017de0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc017de0')) {
      api.createRecord('bc017de0', component.options)
    } else {
      api.reload('bc017de0', component.options)
    }
    module.hot.accept("./CookieBannerPanel.vue?vue&type=template&id=bc017de0&scoped=true", function () {
      api.rerender('bc017de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/CookieBanner/CookieBannerPanel.vue"
export default component.exports